/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ period: NonNullable<unknown> }} Progress_Report_Muscles_EmptyInputs */

const en_us2_progress_report_muscles_empty = /** @type {(inputs: Progress_Report_Muscles_EmptyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`No sets this week.`);
	return /** @type {LocalizedString} */ (`No sets this month.`)
	
};

const pt_br2_progress_report_muscles_empty = /** @type {(inputs: Progress_Report_Muscles_EmptyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Nenhuma série nesta semana.`);
	return /** @type {LocalizedString} */ (`Nenhuma série neste mês.`)
	
};

const es_419_progress_report_muscles_empty = /** @type {(inputs: Progress_Report_Muscles_EmptyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Ninguna serie esta semana.`);
	return /** @type {LocalizedString} */ (`Ninguna serie este mes.`)
	
};

const pt_pt2_progress_report_muscles_empty = /** @type {(inputs: Progress_Report_Muscles_EmptyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Nenhuma série nesta semana.`);
	return /** @type {LocalizedString} */ (`Nenhuma série neste mês.`)
	
};

const fr_fr2_progress_report_muscles_empty = /** @type {(inputs: Progress_Report_Muscles_EmptyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Aucune série cette semaine.`);
	return /** @type {LocalizedString} */ (`Aucune série ce mois-ci.`)
	
};

const de_de2_progress_report_muscles_empty = /** @type {(inputs: Progress_Report_Muscles_EmptyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Keine Sätze diese Woche.`);
	return /** @type {LocalizedString} */ (`Keine Sätze diesen Monat.`)
	
};

const it_it2_progress_report_muscles_empty = /** @type {(inputs: Progress_Report_Muscles_EmptyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Nessuna serie questa settimana.`);
	return /** @type {LocalizedString} */ (`Nessuna serie questo mese.`)
	
};

/**
* | period | output |
* | --- | --- |
* | "week" | "No sets this week." |
* | * | "No sets this month." |
*
* @param {Progress_Report_Muscles_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_muscles_empty = /** @type {((inputs: Progress_Report_Muscles_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Muscles_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_muscles_empty(inputs)
	if (locale === "es-419") return es_419_progress_report_muscles_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_muscles_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_muscles_empty(inputs)
	if (locale === "de-DE") return de_de2_progress_report_muscles_empty(inputs)
	if (locale === "it-IT") return it_it2_progress_report_muscles_empty(inputs)
	return en_us2_progress_report_muscles_empty(inputs)
});
export { progress_report_muscles_empty as "progress-report.muscles_empty" }